import type { ReactNode } from "react";
import { cx } from "./cx";

/** Agrupa quando o agrupamento ajuda a ler. Em lista geral, prefira só fios (sem caixa). */
export function Cartao({ titulo, acao, children, className, semRespiro }: {
  titulo?: ReactNode; acao?: ReactNode; children: ReactNode; className?: string; semRespiro?: boolean;
}) {
  return (
    <section className={cx("min-w-0 rounded-cartao fio bg-superficie", className)}>
      {(titulo || acao) && (
        <header className="flex h-10 items-center justify-between gap-3 fio-b px-4">
          {titulo && <h2 className="text-meta font-medium text-texto-3">{titulo}</h2>}
          {acao}
        </header>
      )}
      <div className={semRespiro ? undefined : "p-4"}>{children}</div>
    </section>
  );
}
